import {
  useSelector as useReduxSelector,
  TypedUseSelectorHook,
} from 'react-redux';

import * as Root from './root';
export const useSelector: TypedUseSelectorHook<Root.State> = useReduxSelector;
